import React, { Component } from 'react'

class FlagData extends Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.id !== this.props.id
  }

  parseProblems() {
    return this.props.flags.reduce((acc, flag) => {
      if (!Object.keys(acc).includes(flag.problem)) {
        acc[flag.problem] = 1
      } else {
        acc[flag.problem] = acc[flag.problem] + 1
      }
      return acc
    }, {})
  }

  renderReasons() {
    const problems = this.parseProblems()
    for (const [problem, amount] of Object.entries(problems)) {
      return (
        <li>
          {problem} ({amount})
        </li>
      )
    }
  }

  render() {
    return (
      <div style={{ padding: 10 }}>
        <p>Tags:</p>
        <ul>{this.renderReasons()}</ul>
      </div>
    )
  }
}

export default FlagData



// WEBPACK FOOTER //
// ./src/views/Components/FlagData.js